export type VideoListingsTheme = 'light' | 'dark';

export type VideoListingsColorToken =
    | 'background'
    | 'surface'
    | 'surfaceElevated'
    | 'border'
    | 'text'
    | 'textSoft'
    | 'textMuted'
    | 'accent'
    | 'accentSoft'
    | 'accentText'
    | 'shadow'
    | 'imageFallback';

export const videoListingsTokens = {
    colors: {
        light: {
            background: '#f6f7fa',
            surface: '#ffffff',
            surfaceElevated: '#f0f3f7',
            border: 'rgba(9, 18, 32, 0.12)',
            text: '#091220',
            textSoft: '#2d3848',
            textMuted: '#667083',
            accent: '#ef242f',
            accentSoft: 'rgba(239, 36, 47, 0.13)',
            accentText: '#ffffff',
            shadow: '0 18px 46px rgba(9, 18, 32, 0.1)',
            imageFallback: '#e3e8ef',
        },
        dark: {
            background: '#070707',
            surface: '#101010',
            surfaceElevated: '#171717',
            border: 'rgba(255, 255, 255, 0.13)',
            text: '#ffffff',
            textSoft: 'rgba(255, 255, 255, 0.78)',
            textMuted: 'rgba(255, 255, 255, 0.58)',
            accent: '#ef242f',
            accentSoft: 'rgba(239, 36, 47, 0.18)',
            accentText: '#ffffff',
            shadow: '0 18px 46px rgba(0, 0, 0, 0.32)',
            imageFallback: '#191919',
        },
    },
    radius: {
        tile: 8,
        media: 7,
        button: 5,
        play: 999,
    },
    sizes: {
        maxWidth: 1440,
        minTileWidth: 260,
        imageHeight: 214,
        featuredImageHeight: 352,
        mobileImageHeight: 190,
    },
    spacing: {
        shellY: 52,
        shellX: 32,
        tabletShellY: 42,
        tabletShellX: 24,
        mobileShellY: 34,
        mobileShellX: 16,
        gap: 24,
        mobileGap: 16,
    },
    typography: {
        fontFamily:
            'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        eyebrow: {
            fontSize: 13,
            mobileFontSize: 11,
            lineHeight: 1,
            fontWeight: 850,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        title: {
            fontSize: 52,
            tabletFontSize: 42,
            mobileFontSize: 31,
            lineHeight: 1.02,
            fontWeight: 900,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        description: {
            fontSize: 18,
            tabletFontSize: 16,
            mobileFontSize: 14,
            lineHeight: 1.45,
            fontWeight: 600,
            letterSpacing: 0,
        },
        tileTitle: {
            fontSize: 20,
            tabletFontSize: 18,
            mobileFontSize: 16,
            lineHeight: 1.14,
            fontWeight: 850,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        featuredTitle: {
            fontSize: 34,
            tabletFontSize: 28,
            mobileFontSize: 22,
            lineHeight: 1.08,
            fontWeight: 900,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        body: {
            fontSize: 16,
            mobileFontSize: 14,
            lineHeight: 1.55,
            fontWeight: 500,
            letterSpacing: 0,
        },
        meta: {
            fontSize: 12,
            mobileFontSize: 11,
            lineHeight: 1,
            fontWeight: 850,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
        cta: {
            fontSize: 13,
            mobileFontSize: 12,
            lineHeight: 1,
            fontWeight: 850,
            letterSpacing: 0,
            textTransform: 'uppercase' as const,
        },
    },
    motion: {
        tile: 'transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease',
        media: 'transform 420ms ease, filter 420ms ease',
        action: 'transform 160ms ease, border-color 160ms ease, background-color 160ms ease, color 160ms ease',
    },
    defaults: {
        eyebrow: 'Latest videos',
        title: 'Latest Videos',
        description: 'Watch recent updates, reviews and field notes from the team.',
        watchLabel: 'Watch video',
        pageLabel: 'View page',
        viewAllLabel: 'View all videos',
        emptyLabel: 'No videos available.',
    },
} as const;
